/**
 * .tuMetrics {"tu1": 0.98, "tu2": 0.99, "tu3": 1, "notes": "Signed-in home is /; /2 kept as redirect alias", "tuVersion": "2.5"}
 * .help "The stream lives at /. Desk pages use /admin, /reports, /updates, /master-control."
 */

/** Signed-in stream home (was /2 while 1.0 coexisted). */
export const HOME_APP = '/';

/** True on Admin / Reports / Updates / Master Control (desk overlays over the stream). */
export function isDeskOverlayPath(pathname: string): boolean {
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return true;
  if (pathname === '/settings/integrations') return true;
  if (pathname === '/updates' || pathname.startsWith('/updates')) return true;
  if (pathname === '/master-control' || pathname.startsWith('/master-control')) return true;
  if (pathname === '/reports' || pathname.startsWith('/reports')) return true;
  return false;
}

/** True on the stream or a 2.0 desk (including legacy /2… while redirects clear). */
export function isAppShellPath(pathname: string): boolean {
  if (pathname === '/' || pathname === '') return true;
  if (pathname === '/2' || pathname.startsWith('/2/')) return true;
  return isDeskOverlayPath(pathname);
}

/** Map a legacy /2… path to the canonical address (pathname only). */
export function canonicalFromLegacyTwo(pathname: string): string {
  if (pathname === '/2' || pathname === '/2/') return HOME_APP;
  if (pathname.startsWith('/2/')) return pathname.slice(2) || HOME_APP;
  return pathname;
}
